module.exports = __webpack_public_path__ + "static/media/8.9041cd14.jpg";